import { foreignProps, reduce } from 'vessel/utils'

const size = foreignProps({
  props: {
    height: {
      type: [Number, String],
      default: null
    },
    maxHeight: {
      type: [Number, String],
      default: null
    },
    minHeight: {
      type: [Number, String],
      default: null
    },
    maxWidth: {
      type: [Number, String],
      default: null
    },
    minWidth: {
      type: [Number, String],
      default: null
    }
  }
})

export default {
  props: {
    ...size.props,
    width: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    $sizes() {
      const props = size.fetch(this.$props)

      props.style = reduce(props, (res, key, value) => {
        if (value != null) {
          const st = value.toString()
          res[key] = st.match(/\d$/) ? `${st}px` : st
        }
      })

      return props
    }
  }
}
